function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useState } from "react";
import styled, { css } from "styled-components";
import BrandContext from "../../../../contexts/BrandContext";
import useBreakpoint from "../../../../hooks/useBreakpoint";
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.406 5.784.246 1.258a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L6 4.22 10.565.216a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 6 6a.901.901 0 0 1-.594-.216Z"
  }));
};
ArrowDown.defaultProps = {
  width: "12",
  height: "6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import space from "../../../../utils/space";
import ArrowLinkAtm from "../../../atoms/ArrowLinkAtm";
import IconAtm from "../../../atoms/IconAtm";
import PlainLinkAtm from "../../../atoms/PlainLinkAtm";
import TextAtm from "../../../atoms/TextAtm";
import AnimateHeightOrg from "../../../organisms/AnimateHeightOrg";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
import PushOrg from "../../../organisms/PushOrg";
import brandStyles from "../brandStyles";
var titleTypography = "xsmall2_u";
var Header = styled.div.withConfig({
  componentId: "sc-10hsp7d-0"
})(function (_ref) {
  var $isClickable = _ref.$isClickable;
  return css(["", ""], $isClickable && css(["cursor:pointer;"]));
});
var Content = styled.div.withConfig({
  componentId: "sc-10hsp7d-1"
})(["margin-top:", ";"], space(2.5));
var ArrowIcon = styled(IconAtm).withConfig({
  componentId: "sc-10hsp7d-2"
})(function (_ref2) {
  var $isOpen = _ref2.$isOpen;
  return css(["", ""], $isOpen && css(["transform:rotate(180deg);"]));
});
function PageFooterCategory(_ref3) {
  var category = _ref3.category,
    isToggleable = _ref3.isToggleable;
  var _useState = useState(category.isClosedOnSmall),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isSmallOnly = useBreakpoint("small", "medium");
  var categoryLinkArrowColor = brandStyles[useContext(BrandContext)].categoryLinkArrowColor;
  var handleOnClick = function handleOnClick() {
    setIsOpen(function (value) {
      return !value;
    });
  };
  var titleJsx = isToggleable && isSmallOnly ? /*#__PURE__*/React.createElement(FlexContainerOrg, null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: titleTypography
  }, category.title), /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 1.5
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    icon: ArrowDown,
    sizeSpace: 1.5,
    $isOpen: !isOpen
  }))) : /*#__PURE__*/React.createElement(TextAtm, {
    typography: titleTypography
  }, category.title);
  var contentJsx = /*#__PURE__*/React.createElement(Content, null, category.links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: 2
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "page-footer-category-link-".concat(index)
    }, /*#__PURE__*/React.createElement(PlainLinkAtm, {
      typography: "small2",
      to: link.to,
      href: link.href,
      title: link.title,
      openInNewTab: link.openInNewTab,
      onClick: link.onClick,
      type: "underline",
      emphasis: "medium"
    }, link.text));
  }), category.categoryLink ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 6
  }, /*#__PURE__*/React.createElement(ArrowLinkAtm, {
    to: category.categoryLink.to,
    href: category.categoryLink.href,
    title: category.categoryLink.title,
    openInNewTab: category.categoryLink.openInNewTab,
    onClick: category.categoryLink.onClick,
    arrowColor: categoryLinkArrowColor
  }, category.categoryLink.text)) : null);
  var contentWrapperJsx = isToggleable && isSmallOnly ? /*#__PURE__*/React.createElement(AnimateHeightOrg, {
    isOpen: !isOpen
  }, contentJsx) : contentJsx;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    $isClickable: isToggleable,
    onClick: handleOnClick
  }, titleJsx), contentWrapperJsx);
}
export default PageFooterCategory;